import { List, Map, Set, Record } from 'immutable'
import { handleActions } from 'redux-actions'
import * as constants from './constants'

const TypingState = Record({
  typingUsersByConversationId: Map(),
})

export default handleActions({
  [constants.TYPING]: (state, action) => {
    const {
      userId,
      userType,
      conversationId,
    } = action.payload
    return state.updateIn(['typingUsersByConversationId', conversationId], (users = Set()) => {
      return users.add(List([userType, userId]))
    })
  },
  [constants.TYPING_FINISHED]: (state, action) => {
    const {
      userId,
      userType,
      conversationId,
    } = action.payload
    return state.updateIn(['typingUsersByConversationId', conversationId], (users = Set()) => {
      return users.remove(List([userType, userId]))
    })
  },
}, TypingState())



// WEBPACK FOOTER //
// ./src/scripts/app/modules/typing/reducer.js